import { render, staticRenderFns } from "./panel.vue?vue&type=template&id=0c78899c&"
import script from "./panel.vue?vue&type=script&lang=ts&"
export * from "./panel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c78899c')) {
      api.createRecord('0c78899c', component.options)
    } else {
      api.reload('0c78899c', component.options)
    }
    module.hot.accept("./panel.vue?vue&type=template&id=0c78899c&", function () {
      api.rerender('0c78899c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/panel.vue"
export default component.exports